import { AnyAction } from 'redux';
import { UNHANDLED_EXCEPTION, SET_EXCEPTION_HANDLER, RESET_STATE, RESET_EXCEPTION, SHELL_CONFIG, SHELL_CONFIG_LOADING, LOADING_DATA, RESET_SCROLL, GRID_CHECK_ALL } from '@app/store/constants';
import { IBasicState, IShellConfig } from '@app/models';

const initialUserState: IBasicState = {
    shellConfig: {} as IShellConfig,
    shellConfigLoading: false,
    loadingData: false,
    hasMoreRequests: true,
    infiniteScrollSkip: 0,
    infiniteScrollLoaded: 0,
    handleExceptions: false,
    unhandledException: {},
    resetScroll: true,
    gridCheckAll: false
};

export function basic(state = initialUserState, action: AnyAction) {
    const { payload, type } = action;

    switch (type) {
        case RESET_STATE:
            return {
                ...state,
                gridCheckAll: false
            };
        case RESET_EXCEPTION:
            return {
                ...state,
                handleExceptions: false,
                unhandledException: {}
            };
        case SHELL_CONFIG:
            return {
                ...state,
                shellConfig: payload
            };

        case SHELL_CONFIG_LOADING:
            return {
                ...state,
                shellConfigLoading: payload
            };

        case LOADING_DATA:
            return {
                ...state,
                loadingData: payload
            };

        case SET_EXCEPTION_HANDLER:
            return {
                ...state,
                handleExceptions: payload
            };

        case UNHANDLED_EXCEPTION:
            return {
                ...state,
                unhandledException: payload
            };

        case RESET_SCROLL:
            return {
                ...state,
                resetScroll: !state.resetScroll
            };

        case GRID_CHECK_ALL:
            return {
                ...state,
                gridCheckAll: payload
            };

        default:
            return state;
    }
}
